import React, { useState, useEffect, useRef } from "react";
import { withSnackbar } from "notistack";
import { Grid, Table, TableBody, Paper } from "@material-ui/core";
import { Tooltip, Dialog } from "@material-ui/core";
import { OccmTaskForm, OccmList } from "../components";
import OccmHd from "../components/OccmHd";
import BasicDetailHeader from "../../BasicDetailHeader";
import { assetFilterOps } from "./OccmTableHead";
import { EmptyCollection, PageLoader, AccessDenied, DeletePopUp } from "../../../../shared_elements";
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo, downloadFileType, checkApiStatus } from "../../../../utils";
import { globalGetService, globalDeleteService, globalExportService, globalFileUploadService, globalPutService } from "../../../../utils/globalApiServices";
import { trackActivity } from '../../../../utils/mixpanel';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import moment from "moment";
import Pagination from "../../../../shared_elements/components/Pagination";
import ImportFileModule from "../../../../shared_elements/components/import_Format/ImportFileModule";
import SubDetails from "../../../../shared_elements/components/sub_details/SubDetails";
import CtaAction from "../../../../shared_elements/components/cta/CtaAction";
const OccmComponents = (props) => {
	const { enqueueSnackbar, match, aircraftTypes, engineTypes, lessees } = props;

	const [pageLoader, setPageLoader] = useState(false);
	const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
	const [filter, setFilter] = useState({});
	const [assetsDetail, setAssetsDetail] = useState({ list: [], pagination: {}, new_task_last_used_folder_uuid: '', last_used_folder_uuid_link_document: '', checkbox_last_used_folder_uuid: '', checkbox_last_used_folder_name: '' });
	const [occmCRU, setOccmCRU] = useState({ modal: false, data: null, mode: '' });
	const [deleteModal, setDeleteModal] = useState({ modal: false, data: null });
	const [importFiles, setImportFiles] = useState({ modal: false });
	const [slug, setSlug] = useState("");
	const [uuid, setUuid] = useState("");
	const [isBasicDetailExpanded, setIsBasicDetailExpanded] = useState(true);
	const [basicDetails, setBasicDetails] = useState({});
	const tabIndex = 0;
	const timeoutRef = useRef(null);
	const currentRecordPerPageRef = useRef(250);

	const getOccmData = (queryParams = {}, searchString = null) => {
		if (!permissionCheckFnforCamo({ primaryKey: "occm_component", keyIndex: "R" })) return;
		setPageLoader(true);
		clearTimeout(timeoutRef.current);
		timeoutRef.current = setTimeout(() => {
			const { asset, assetType: assetTypeParam } = match.params;
			globalGetService('camo/occm/list/', {
				...queryParams,
				per_page: queryParams.per_page || currentRecordPerPageRef.current,
				asset,
				asset_type: assetTypeParam,
				search: searchString,
			}).then((response) => {
				if (response.status === 500) {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
					setPageLoader(false);
					return;
				}
				const cleanFilter = { ...queryParams };
				delete cleanFilter.page;
				delete cleanFilter.per_page;
				delete cleanFilter.asset_type;
				delete cleanFilter.sort;
				delete cleanFilter.sort_by;
				setFilter(cleanFilter);
				setPageLoader(false);
				setAssetsDetail(prev => ({
					...prev,
					list: response.data.results,
					pagination: {
						...prev.pagination,
						total: response.data.pagination.total,
						per_page: response.data.pagination.per_page,
						page: parseInt(response.data.pagination.current_page),
					},
					new_task_last_used_folder_uuid: response.data.new_task_last_used_folder_uuid,
					last_used_folder_uuid_link_document: response.data.last_used_folder_uuid_link_document,
					checkbox_last_used_folder_uuid: response.data.checkbox_last_used_folder_uuid,
					checkbox_last_used_folder_name: response.data.checkbox_last_used_folder_name,
				}));
			});
		}, 500);
	};

	useEffect(() => {
		getOccmData({ per_page: currentRecordPerPageRef.current });
		trackActivity('CAMO', {
			event_type: 'Page Visited',
			page_title: 'OCCM Components',
		});
	}, []);

	const pullData = (slugVal) => {
		setSlug(slugVal);
	};

	const uuidData = (uuidVal) => {
		setUuid(uuidVal);
	};

	const deleteOccmRecord = () => {
		const item = deleteModal.data;
		globalDeleteService(`camo/occm/${item.id}/delete/`).then((response) => {
			setDeleteModal({ modal: false, data: null });
			if (response.status === 200) {
				enqueueSnackbar("Record Deleted Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
				trackActivity('CAMO', { event_type: 'Item Deleted', page_title: 'Asset Detail Row', item_id: item.id || '' });
			}
			if (response.status === 500) {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
			getOccmData({ per_page: currentRecordPerPageRef.current });
		});
	};

	const createSortHandler = (sortField) => {
		const newSortBy = sortField === sortInfo.sort ? (sortInfo.sort_by === "asc" ? "desc" : "asc") : "asc";
		const newSortInfo = { sort: sortField, sort_by: newSortBy };
		setSortInfo(newSortInfo);
		getOccmData({
			...filter,
			...newSortInfo,
			per_page: assetsDetail.pagination.per_page,
			asset_type: tabIndex,
		});
	};

	const updateFormData = (updateId, updatedData) => {
		if (!permissionCheckFnforCamo({ primaryKey: "occm_component", keyIndex: "U" })) return;
		setPageLoader(true);
		globalPutService(`camo/occm/${updateId}/update/`, updatedData).then((response) => {
			if (response.status === 500 || response?.data?.statusCode === 500) {
				enqueueSnackbar(
					response?.data?.statusCode === 500 ? response?.data?.message : "Something went wrong.",
					{ variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } }
				);
			} else {
				setPageLoader(false);
				enqueueSnackbar("Record Updated Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
				getOccmData({ per_page: currentRecordPerPageRef.current });
			}
		});
	};

	const fileUploadData = (_uploadId, formdata, _prps, haveAttachments) => {
		setPageLoader(true);
		if (haveAttachments) {
			globalFileUploadService('camo/attachment/upload/', formdata).then((response) => {
				if (response.status === 500) {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				} else {
					setPageLoader(false);
					getOccmData({ per_page: currentRecordPerPageRef.current });
				}
			}).catch((err) => { console.error(err); });
		} else {
			enqueueSnackbar("Data Submitted Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
			setPageLoader(false);
			getOccmData({ per_page: currentRecordPerPageRef.current });
		}
	};

	const exportAssetDetailList = (extension) => {
		setPageLoader(true);
		const todayDate = moment(new Date()).format("YYYY-MM-DD");
		const { asset, assetType: assetTypeParam } = match.params;
		const exportParams = { ...convertFilterObject(removeEmptyKey(filter), filterOptions) };
		delete exportParams.asset_type;
		globalExportService(
			assetTypeParam == 2
				? `/camo/occm/engine/${asset}/${assetTypeParam}/export/`
				: `/camo/occm/${asset}/${assetTypeParam}/export/`,
			{ download: extension, ...exportParams }
		).then((response) => {
			setPageLoader(false);
			if (checkApiStatus(response)) {
				downloadFileType(response.data, `${todayDate}_ESN ${basicDetails?.esn || basicDetails?.msn}_OCCM`, extension);
				enqueueSnackbar("Download of Occm List successful", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
				trackActivity("CAMO", { event_type: "Item Exported", page_title: "Asset Listing", extension });
			} else {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
		});
	};

	const downloadSampleFile = (extension) => {
		setPageLoader(true);
		const {assetType: assetTypeParam } = match.params;
		globalExportService(`camo/occm/sample-file/${assetTypeParam}/`).then((response) => {
			setPageLoader(false);
			if (checkApiStatus(response)) {
				downloadFileType(response.data, 'SampleFile_OCCM', extension);
				trackActivity("CAMO", { event_type: 'Sample File Downloaded', page_title: "OC-CM", extension });
			} else {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
		});
	};

	const downloadAllFiles = async (item) => {
		setPageLoader(true);
		const attachment_list = item.download_attachments.map(entry => [entry[0], decodeURIComponent(entry[1])]);
		const zip = new JSZip();
		const folder = zip.folder('DownloadedFiles');
		try {
			const downloadPromises = attachment_list.map(async (entry) => {
				const res = await fetch(entry[1] || '');
				if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
				const blob = await res.blob();
				folder.file(entry[0], blob);
			});
			await Promise.all(downloadPromises);
			const content = await zip.generateAsync({ type: 'blob' });
			saveAs(content, 'OCCM.zip');
			setPageLoader(false);
		} catch (error) {
			console.error('Error:', error);
			setPageLoader(false);
		}
	};

	const refreshComp = () => {
		getOccmData({ per_page: currentRecordPerPageRef.current });
	};

	let filterOptions = { ...assetFilterOps };
	if (tabIndex === 0 || tabIndex === 1) {
		filterOptions = { ...filterOptions, aircraft_type: { ...filterOptions.aircraft_type, options: aircraftTypes } };
		if (tabIndex === 1) delete filterOptions.engine_type;
	}
	if (tabIndex === 0 || tabIndex === 2) {
		filterOptions = { ...filterOptions, engine_type: { ...filterOptions.engine_type, options: engineTypes } };
		if (tabIndex === 2) delete filterOptions.aircraft_type;
	}
	filterOptions = { ...filterOptions, lessee: { ...filterOptions.lessee, options: lessees } };

	return (
		<section className="amp-listing-section">
			{pageLoader ? <PageLoader /> : null}
			<Grid style={{ marginTop: 0 }} spacing={3} container>
				<Grid style={{ paddingTop: 0, paddingRight: 0 }} xs={12} item>
					<SubDetails
						masterExport={false}
						title="OC-CM Components"
						slug={slug}
						match={match}
						onRefresh={() => getOccmData({ per_page: 250 })}
						permissionCheck={permissionCheckFnforCamo({ primaryKey: "occm_component", keyIndex: "U" })}
					/>
					<BasicDetailHeader props={props} func={pullData} uuid={uuidData} module='occm' engineType={(data) => setBasicDetails(data)} onAccordionChange={setIsBasicDetailExpanded} />
					{permissionCheckFnforCamo({ primaryKey: "occm_component", keyIndex: "R" }) ? (
						<Paper square style={{ padding: "5px", marginTop: "10px" }} variant="outlined">
							<CtaAction
								searchPlaceholder="Search ATA Chapter, Part Description, Part Number, Part Serial Number"
								onSearch={(value) => getOccmData({ per_page: currentRecordPerPageRef.current }, value)}
								permissionCheck={!permissionCheckFnforCamo({ primaryKey: "occm_component", keyIndex: "C" }) || window?.location?.search.includes('archived-assets')}
								addLabel="ADD OC-CM COMPONENTS"
								onAddFn={() => setOccmCRU({ modal: true, data: null, mode: 'add' })}
								onImportFn={() => setImportFiles({ modal: true })}
								exportMenu={{
									exportReportFn: (file) => exportAssetDetailList(file?.extension),
									files: [{ title: 'EXCEL', extension: 'xlsx' }, { title: 'PDF', extension: 'pdf' }],
									disabled: !assetsDetail?.list?.length,
								}}
								downloadSampleMenu={{
									exportReportFn: (file) => downloadSampleFile(file?.extension),
									files: [{ title: 'DOWNLOAD SAMPLE', extension: 'xlsx', type: 'sample' }],
								}}
							/>
							<div style={{ height: `${window.innerHeight - (isBasicDetailExpanded ? 425 : 290)}px`, overflow: 'auto' }}>
								<Table className="mui-table-format" stickyHeader>
									<OccmHd
										sort={sortInfo.sort}
										sort_by={sortInfo.sort_by}
										createSortHandler={createSortHandler}
									/>
									<TableBody>
										{assetsDetail.list.map((item, index) => (
											<OccmList
												key={index}
												item={item}
												uuid={uuid}
												assetsDetail={assetsDetail}
												getResponseBack={refreshComp}
												last_used_folder_uuid={assetsDetail.new_task_last_used_folder_uuid}
												last_used_folder_uuid_link_document={assetsDetail.last_used_folder_uuid_link_document}
												checkbox_last_used_folder_uuid={assetsDetail.checkbox_last_used_folder_uuid}
												checkbox_last_used_folder_name={assetsDetail.checkbox_last_used_folder_name}
												index={index}
												toggleDelteModalFn={() => setDeleteModal({ modal: true, data: item })}
												updateFormData={updateFormData}
												props={props}
												fileUploadData={fileUploadData}
												downloadAllApi={() => downloadAllFiles(item)}
												currentRecordPerPage={currentRecordPerPageRef.current}
											/>
										))}
									</TableBody>
								</Table>
								{!assetsDetail.list.length ? <EmptyCollection title="No Records Found" /> : null}
							</div>
							<Pagination
								pagination={assetsDetail.pagination}
								onChangeRowsPerPage={(event) => {
									currentRecordPerPageRef.current = event.target.value;
									getOccmData({ page: 1, per_page: event.target.value });
								}}
								onChangePage={(event, newPage) => getOccmData({
									...convertFilterObject(removeEmptyKey({ ...filter, asset_type: tabIndex }), filterOptions),
									per_page: assetsDetail.pagination.per_page,
									page: newPage + 1,
								})}
							/>
						</Paper>
					) : (
						<AccessDenied />
					)}
				</Grid>
			</Grid>

			{occmCRU?.modal ? (
				<Dialog open={true} maxWidth="lg" fullWidth>
					<OccmTaskForm
						formTitle="OC-CM Components"
						closeAddForm={() => setOccmCRU({ modal: false, data: null, mode: '' })}
						props={props}
						actionType={occmCRU.mode}
						fileUploadData={fileUploadData}
						uuid={uuid}
						getResponseBack={refreshComp}
						last_used_folder_uuid={assetsDetail.new_task_last_used_folder_uuid}
						last_used_folder_uuid_link_document={assetsDetail.last_used_folder_uuid_link_document}
						checkbox_last_used_folder_uuid={assetsDetail.checkbox_last_used_folder_uuid}
						checkbox_last_used_folder_name={assetsDetail.checkbox_last_used_folder_name}
					/>
				</Dialog>
			) : null}

			{deleteModal?.modal ? (
				<DeletePopUp
					title="Delete OC-CM Record"
					deleteRecordFn={deleteOccmRecord}
					modal={true}
					content="Do you really want to delete this record?"
					toggleModalFn={() => setDeleteModal({ modal: false, data: null })}
				/>
			) : null}

			{importFiles?.modal ? (
				<ImportFileModule
					importUrl={`camo/occm/${match?.params?.asset}/${match?.params?.assetType}/import/`}
					title="Import OC-CM Components"
					getResponseBack={refreshComp}
					toggleModalFn={() => setImportFiles({ modal: false })}
				/>
			) : null}
		</section>
	);
};

export default withSnackbar(OccmComponents);
